export default __webpack_public_path__ + "tmp_src/components/PdpVariantTable/PdpVariantTable.css.liquid";